// extracted by mini-css-extract-plugin
module.exports = {"emptyState":"SettingsAlertingEmpty_emptyState__2-4uo","text":"SettingsAlertingEmpty_text__X6WOG"};